<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <form class="h-100 scrollable padded">
    <template v-for="change in value.statusChanges">
      <log-entry
        :variant="variantFor(change.status)"
        :key="change.id"
        :user="change.person.firstName + ' ' + change.person.lastName"
        :text="change.status.label"
        :timestamp="timestampFor(change)"
      />
    </template>
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";
import { formatDateTime } from "core/utils";

export default {
  mixins: [EditorMixin, ErrorCounterMixin],

  methods: {
    timestampFor(m) {
      // TODO externalize
      return formatDateTime(m.created, "DD/MM/YYYY HH:mm");
    },

    variantFor(s) {
      switch (s.type) {
        case "INITIAL":
          return "info";
        case "INTERMEDIATE":
          return "warning";
        case "SUCCESS":
          return "success";
        case "FAILURE":
          return "danger";
      }
      throw Error("Unsupported type");
    }
  }
};
</script>
